(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moore-home"] && !Shopify.designMode) return;
  try {
    
  document.documentElement.classList.add('msw-motion-ready');
  const mswItems = document.querySelectorAll('.msw-reveal');
  if ('IntersectionObserver' in window) {
    const mswObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          mswObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -7% 0px' });
    mswItems.forEach((item) => mswObserver.observe(item));
  } else {
    mswItems.forEach((item) => item.classList.add('is-visible'));
  }

  } catch(e) { console.error(e); }
})();
})();
